import { Component } from 'react';
import PropTypes from 'prop-types';
import { map, isEmpty } from 'lodash';
import Post from './components/post';
import { Wrap } from '../../../../../styled';
import { Posts, Button } from './styled';

export default class List extends Component {
  getLoadMoreButton() {
    const { hasNextPage, loadNextPage, isLoading } = this.props;

    if (!hasNextPage) {
      return null;
    }

    return (
      <Button onClick={loadNextPage} disabled={isLoading}>
        Load more
      </Button>
    );
  }

  getPosts() {
    const { posts, formatDate } = this.props;

    const hasNoPosts = isEmpty(posts);

    if (hasNoPosts) {
      return null;
    }

    return (
      <>
        <Posts>
          {map(posts, (item) => {
            const { id, title, thumbnail, date, author, slug } = item;

            return (
              <Post
                key={id}
                slug={slug}
                thumbnail={thumbnail}
                title={title}
                date={formatDate(date)}
                author={`by ${author}`}
              />
            );
          })}
        </Posts>
        {this.getLoadMoreButton()}
      </>
    );
  }

  render() {
    return (
      <Wrap>
        <h1>Latest posts</h1>
        {this.getPosts()}
      </Wrap>
    );
  }
}

List.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      author: PropTypes.string.isRequired,
    }).isRequired
  ),
  hasNextPage: PropTypes.bool.isRequired,
  loadNextPage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formatDate: PropTypes.func.isRequired,
};

List.defaultProps = {
  posts: null,
};
